var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2.75C18.1927 2.75 14.4709 3.87899 11.3053 5.99421C8.13964 8.10943 5.67231 11.1159 4.21533 14.6333C2.75834 18.1508 2.37713 22.0214 3.11989 25.7555C3.86266 29.4896 5.69604 32.9196 8.3882 35.6118C11.0804 38.304 14.5104 40.1374 18.2445 40.8801C21.9787 41.6229 25.8492 41.2417 29.3667 39.7847C32.8841 38.3277 35.8906 35.8604 38.0058 32.6947C40.121 29.5291 41.25 25.8073 41.25 22C41.25 16.8946 39.2219 11.9983 35.6118 8.38819C32.0017 4.77812 27.1054 2.75 22 2.75ZM19.25 29.6873L12.375 22.8123L14.5621 20.625L19.25 25.3127L29.4388 15.125L31.6328 17.3056L19.25 29.6873Z",
    fill: "#09A56F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkStroke);
export default __webpack_public_path__ + "static/media/checkmark-stroke.f1a40714670a3c9a0a4dd767a5358656.svg";
export { ForwardRef as ReactComponent };